<template>
  <AppAddUpdateModal
    size="lg"
    :id="id"
    :title="(scopeToEdit ? $t($getConst.pages.scope.update_new_scope) : $t($getConst.pages.scope.add_new_scope)) | capitalize">
    <template v-slot:form>
      <ScopeForm :modal_id="id" :scopeToEdit="scopeToEdit" :languages="languages"/>
    </template>
  </AppAddUpdateModal>
</template>

<script>
  import ScopeForm from "./ScopeForm";
  import AppAddUpdateModal from "../../../components/common/modals/AppAddUpdateModal";
  export default {
    name: "ScopeModal",
    components: {ScopeForm, AppAddUpdateModal},
    props: {
      id: null,
      scopeToEdit: null,
      languages: Array,
    }
  }
</script>

<style scoped>

</style>
